import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import HoverLinkBtn from "../../components/common/button/HoverLinkBtn";
import CustomTitle from "../../components/common/title/CustomTitle";
import { Redirect } from "react-router-dom";
import { userDropAction, userErrClearAction } from "../../modules/su/userInfoModule";
import CheckBoxInput from '../../components/common/input/CheckBoxInput';
import TextArea from '../../components/common/textarea/TextArea';
import NormalBtn from '../../components/common/button/NormalBtn';
import NormalInput from '../../components/common/input/NormalInput';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../../components/common/popup/NormalPopup';
import NormalPopupOneBtn from '../../components/common/popup/NormalPopupOneBtn';
import { useHistory } from 'react-router-dom';
import { logoutAction } from '../../modules/su/userModule';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MyDropBlock = styled.div``;

const MyDropWrapBlock = styled.div`
    ${isMobileOnly?`
    margin: 0 4vw; 
    padding: 120px 0 120px;    
    `:`
    padding: 140px 0 120px;
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
    `};

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const MyDropLnbBlock = styled.div`
    float: left;
    ${isMobileOnly?`
    width: 100%;     
  `:`
    width: 234px;
    padding-right: 40px;
  `};

    h2 {
        margin-bottom: 50px;
        font-size: 32px;
        font-weight: 700;
    }
`;

const MyDropLnbUlContainBlock = styled.div`
    ${isMobileOnly?`
    width: 100%;
    //overflow: scroll hidden;  
    overflow-x: scroll;
    overflow-y: hidden; 
    height: 35px;
    margin-bottom: 10vw;
    border-bottom: 1px solid #111; 
  `:`
    
  `};
`;

const MyDropLnbLiBlock = styled.li`
    margin-bottom: 30px;
    color: #333;
    font-size: 20px;
    font-weight: 500;

    ${isMobileOnly&&"float: left"};
    ${isMobileOnly&&"margin-right: 4vw"};
`;

const MyDropContentsBlock = styled.div`
    float: left;
    ${isMobileOnly?`
    width: 100%;
  `:`
    width: 936px;
  `};
`;

const MyDropTableWrapBlock = styled.div`
    width: 100%;
    border-top: 2px solid #111
    margin-bottom: 50px;

    .dt-title {
        padding-bottom: 20px;
        font-size: 18px;
        font-weight: 700;
    }
`;

const MyDropButtonBlock = styled.button`
    pointer-events: ${props => props.disable};
    background-color: ${props => props.colorF};
    color: ${props => props.textColor || '#fff'} ;
    //border: 1px solid ${props => props.colorF};
    width : 140px ;
    height: 40px;
    display : inline-block;
    border-radius: 20px; 
    font-weight : 400;
    
    ${isMobileOnly?`
    margin-right: 2vw;
  `:`
    margin-right: 30px;
  `};
    font-size: 14px;
`;

const MyDropGridItmeBlock = styled.div`
    height : 40px;
`;


const MyDrop = () => {
    const Options = [
        { value: false, label: "상품 다양성 부족 / 가격 불만 / 품질 불만" },
        { value: false, label: "브랜드 - 다양성 부족" },
        { value: false, label: "견적 요청 불편,어려움 / 견적 반응 느림" },
        { value: false, label: "쇼핑 혜택 / 회원 혜택 부족" },
        { value: false, label: "배송불만" },
        { value: false, label: "교환/반품 불만" },
        { value: false, label: "개인정보유출 우려" },
        { value: false, label: "이용 빈도 낮음" },
        { value: false, label: "사이트 이용 불편" },
        { value: false, label: "기타사유" },
    ];

    const dispatch = useDispatch();
    const [reason, setReason] = useState(Options);
    const [reasonText, setReasonText] = useState("");
    const [reasonDetailText, setReasonDetailText] = useState("");
    const [confirm, setConfirm] = useState(false);
    const [openModal1, setOpenModal1] = useState(false);
    const [openModal2, setOpenModal2] = useState(false);
    const history = useHistory();
    const [textQuestion, setTextQuestion] = useState("정말 회원 탈퇴하실 건가요?\n다시 한번 생각해주세요.");
    const [textDrop, setTextDrop] = useState("회원탈퇴 되었습니다.\n그동안 서비스를 이용해주셔서 감사합니다.");

    const { loading, accessToken, code, action , errMsg} = useSelector(
        ({ userReducer, loadingReducer, userInfoReducer }) => ({
            registError: userReducer.registError,
            loading: loadingReducer['user/REGIST'],
            regStatus: userReducer.regStatus,
            accessToken: userReducer.accessToken,
            code: userInfoReducer.code,
            action: userInfoReducer.action,
            errMsg: userInfoReducer.err,
        })
    );

    useEffect(() => {
        dispatch(setCurMenuAction('mp'));
        dispatch(setHeaderTransferAction(false));
        window.scrollTo(0, 0);
    }, []);

    const menuTitle = [
        { title: '나의견적', link: '/es', isUnderLine: false },
        { title: '나의클립북', link: '/myclip', isUnderLine: false },
        { title: '회원정보관리', link: '/mysetting', isUnderLine: true },
        { title: '1:1 문의 내역', link: '/myquestion', isUnderLine: false }
    ]

    useEffect(() => {
        setOpenModal2(false);
        // 업데이트 완료 시 팝업 표시
        if (code === 200 && action === 'userinfo/DROP_SUCCESS') {
          setOpenModal1(true);
          setTextDrop("회원탈퇴 되었습니다.\n그동안 서비스를 이용해주셔서 감사합니다.");
        }
        else if (code !== 200 && action === 'userinfo/DROP_FAILURE'){
            setOpenModal1(true);
            setTextDrop("업데이트 중 오류가 발생하였습니다.");
        }
      }, [code, action])

    const handleReason0 = (isOn) => {
        let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[0].value = !reasonT[0].value;
        setReason(reasonT);
    }

    const handleReason1 = (isOn) => {
        let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[1].value = !reasonT[1].value;
        setReason(reasonT);
    }

    const handleReason2 = (isOn) => {
        let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[2].value = !reasonT[2].value;
        setReason(reasonT);
    }

    const handleReason3 = (isOn) => {
        let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[3].value = !reasonT[3].value;
        setReason(reasonT);
    }

    const handleReason4 = (isOn) => {
        let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[4].value = !reasonT[4].value;
        setReason(reasonT);
    }

    const handleReason5 = (isOn) => {
        let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[5].value = !reasonT[5].value;
        setReason(reasonT);
    }

    const handleReason6 = (isOn) => {
        let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[6].value = !reasonT[6].value;
        setReason(reasonT);
    }

    const handleReason7 = (isOn) => {
        let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[7].value = !reasonT[7].value;
        setReason(reasonT);
    }

    const handleReason8 = (isOn) => {
        let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[8].value = !reasonT[8].value;
        setReason(reasonT);
    }

    const handleReason9 = (isOn) => {
        return;
        /* let reasonT = [];
        Object.assign(reasonT, reason);
        reasonT[9].value = !reasonT[9].value;
        setReason(reasonT); */
    }

    const hanldeReasonInput = (e) => {

        setReasonText(e.target.value);
        if(e.target.value.length > 0){
            let reasonT = [];
            Object.assign(reasonT, reason);
            reasonT[9].value = true;
            setReason(reasonT);
        }
        else{
            let reasonT = [];
            Object.assign(reasonT, reason);
            reasonT[9].value = false;
            setReason(reasonT);
        }
    }

    const hanldeReasonDetailInput = (e) => {

        if(e.target.value && e.target.value.length <= 2000){
            setReasonDetailText(e.target.value);
        }

    }

    const handleConfirm = (isOn) => {
        setConfirm(!confirm);
    }

    const handleApply = () => {
        setOpenModal2(true);
    }

    const handleCancel = () => {
        history.push("/mysetting");
    }

    const handleOneBtnPopupClick = () => {
        setOpenModal1(false);
        if (code === 200 && action === 'userinfo/DROP_SUCCESS'){
            dispatch(logoutAction());
            history.push("/");
        }

        dispatch(userErrClearAction());
    }

    const handleModalDropBtnClick = () => {
        if(checkValid()){
            //drop_reason, drop_reason_detail
            let drop_reason = "";
            let drop_reason_detail = "";
            if(reasonDetailText !== null && reasonDetailText.length > 0){
                drop_reason_detail = reasonDetailText;
            }

            for(var i = 0; i < reason.length - 1; i++){
                if(reason[i].value){
                    if(drop_reason.length === 0){
                        drop_reason = reason[i].label;
                    }
                    else{
                        drop_reason += ", " + reason[i].label;
                    }
                }
            }

            if(reasonText !== null && reasonText.length > 0){
                if(drop_reason.length === 0){
                    drop_reason = reasonText;
                }
                else{
                    drop_reason += ", " + reasonText;
                }
            }

            dispatch(userDropAction(drop_reason,drop_reason_detail));
        }
    }

    const checkValid = () => {

        if(confirm){
            for(var i = 0; i < reason.length - 1; i++){
                if(reason[i].value){
                    return true;
                }
            }

            if(reasonText !== null && reasonText.length > 0){
                return true;
            }
        }

        return false;
    }

    // 로그인 상태가 아니라면
    if (accessToken === null) {
        return <Redirect to="/" />
    }

    return (
        <MyDropBlock>
            <Header />
            <MyDropWrapBlock>
                <MyDropLnbBlock>
                    <h2>마이페이지</h2>
                    <MyDropLnbUlContainBlock>
                    <ul style = {isMobileOnly? {width:'max-content'}:{}}>
                        {
                            menuTitle.map((curitem, idx) => {
                                return (
                                    <MyDropLnbLiBlock key={idx}>
                                        <HoverLinkBtn
                                            text={curitem.title}
                                            bottom="2px"
                                            height="4px"
                                            link={curitem.link}
                                            isDot={false}
                                            isUnderLine={curitem.isUnderLine}
                                        >
                                        </HoverLinkBtn>
                                    </MyDropLnbLiBlock>
                                );
                            })
                        }
                    </ul>
                    </MyDropLnbUlContainBlock>
                </MyDropLnbBlock>
                <MyDropContentsBlock>
                    <CustomTitle marginBottom="58px" textColor="#333"
                        fontSize="24px" fontWeight="300" title="회원 탈퇴" textAlign="left" />

                    <MyDropTableWrapBlock>

                        {isMobileOnly ?
                        <div className="default-table margin_b-50">
                            <h3 className="dt-title" style={{borderBottom:'2px solid #111'}}>탈퇴 하시려는 이유를 선택해 주세요. </h3>
                            <span className="leave_text" style={{float:"right"}}>1개 이상 선택 필수</span>
                            <table style={{borderTop:'none'}}>
                                <tbody>
                                    <tr>
                                        <td className="border_bottom" style={{paddingLeft:'0px', paddingTop:'0px', borderTop:'none'}}>
                                            <div className="grid-3 margin_b-20">
                                                <MyDropGridItmeBlock>
                                                    <CheckBoxInput title={reason[0].label} onClick={handleReason0} defaultValue={reason[0].value}
                                                    labelmargin="0px 0px 0px 7px" margin="0px" />
                                                </MyDropGridItmeBlock>
                                                <MyDropGridItmeBlock>
                                                    <CheckBoxInput title={reason[1].label} onClick={handleReason1} defaultValue={reason[1].value}
                                                    labelmargin="0px 0px 0px 7px" margin="0px"/>
                                                </MyDropGridItmeBlock>
                                                <MyDropGridItmeBlock>
                                                    <CheckBoxInput title={reason[2].label} onClick={handleReason2} defaultValue={reason[2].value}
                                                    labelmargin="0px 0px 0px 7px" margin="0px"/>
                                                </MyDropGridItmeBlock>
                                                <MyDropGridItmeBlock>
                                                    <CheckBoxInput title={reason[3].label} onClick={handleReason3} defaultValue={reason[3].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </MyDropGridItmeBlock>
                                                <MyDropGridItmeBlock>
                                                    <CheckBoxInput title={reason[4].label} onClick={handleReason4} defaultValue={reason[4].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </MyDropGridItmeBlock>
                                                <MyDropGridItmeBlock>
                                                    <CheckBoxInput title={reason[5].label} onClick={handleReason5} defaultValue={reason[5].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </MyDropGridItmeBlock>
                                                <MyDropGridItmeBlock>
                                                    <CheckBoxInput title={reason[6].label} onClick={handleReason6} defaultValue={reason[6].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </MyDropGridItmeBlock>
                                                <MyDropGridItmeBlock>
                                                    <CheckBoxInput title={reason[7].label} onClick={handleReason7} defaultValue={reason[7].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </MyDropGridItmeBlock>
                                                <MyDropGridItmeBlock>
                                                    <CheckBoxInput title={reason[8].label} onClick={handleReason8} defaultValue={reason[8].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </MyDropGridItmeBlock>
                                                <MyDropGridItmeBlock style={{height:'75px'}}>
                                                    <CheckBoxInput title={reason[9].label} onClick={handleReason9} defaultValue={reason[9].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                    <div style = {{display: 'inline-block', width: '100%', marginLeft: '0px', verticalAlign: 'middle'}}>
                                                    <NormalInput type="text" maxLength="100" marginBottom="0px"
                                                                                placeholder="" width="100%" float="right" marginInnerTop="0px"
                                                                                onChange={hanldeReasonInput} dispError={false} />
                                                    </div>
                                                </MyDropGridItmeBlock>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        :
                        <div className="default-table margin_b-50">
                            <h3 className="dt-title">탈퇴 하시려는 이유를 선택해 주세요. <span className="leave_text" style={{float:"right"}}>1개 이상 선택 필수</span></h3>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="border_bottom">
                                            <div className="grid-3 margin_b-20" style={{height:'32px'}}>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[0].label} onClick={handleReason0} defaultValue={reason[0].value}
                                                    labelmargin="0px 0px 0px 7px" margin="0px" />
                                                </div>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[1].label} onClick={handleReason1} defaultValue={reason[1].value}
                                                    labelmargin="0px 0px 0px 7px" margin="0px"/>
                                                </div>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[2].label} onClick={handleReason2} defaultValue={reason[2].value}
                                                    labelmargin="0px 0px 0px 7px" margin="0px"/>
                                                </div>
                                            </div>
                                            <div className="grid-3 margin_b-20" style={{height:'32px'}}>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[3].label} onClick={handleReason3} defaultValue={reason[3].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </div>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[4].label} onClick={handleReason4} defaultValue={reason[4].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </div>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[5].label} onClick={handleReason5} defaultValue={reason[5].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </div>
                                            </div>
                                            <div className="grid-3 margin_b-20" style={{height:'32px'}}>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[6].label} onClick={handleReason6} defaultValue={reason[6].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </div>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[7].label} onClick={handleReason7} defaultValue={reason[7].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </div>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[8].label} onClick={handleReason8} defaultValue={reason[8].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="grid-item">
                                                    <CheckBoxInput title={reason[9].label} onClick={handleReason9} defaultValue={reason[9].value}
                                                    labelmargin="0px 0px 0px 7px" />
                                                    <div style = {{display: 'inline-block', width: '783px', marginLeft: '20px', verticalAlign: 'middle'}}>
                                                    <NormalInput type="text" maxLength="100" marginBottom="0px"
                                                                                placeholder="" width="100%" float="right" marginInnerTop="0px"
                                                                                onChange={hanldeReasonInput} dispError={false} />
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        }

                        <div className="default-table margin_b-50">
                            <h3 className="dt-title">서비스 이용 도중 어떤 부분이 불편 하셨나요?</h3>
                            <table>
                                <colgroup>
                                    <col width="33.33%" />
                                    <col width="33.33%" />
                                    <col width="33.33%" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <td className="border_bottom">
                                            <div className="input-box">
                                                <TextArea placeholder="불편사항을 보다 자세히 알려주신다면, 의견을 반영하여 더 좋은 서비스로 개선해 나가겠습니다."
                                                                                height="160px" onChange={hanldeReasonDetailInput} value={reasonDetailText}/>
                                                <p className="ess_text clearfix">
                                                    <span className="f-right"> {reasonDetailText.length}/최대 2000자</span>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="default-table margin_b-50">
                            <h3 className="dt-title">회원 탈퇴 시 아래 사항을 반드시 확인해 주세요.</h3>
                            <table>
                                <colgroup>
                                    <col width="33.33%" />
                                    <col width="33.33%" />
                                    <col width="33.33%" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <td className="border_bottom11" style={{paddingBottom:'0px'}}>
                                            <div className="leave-terms small_scroll margin_b-20">
                                                    기존 견적서는 탈퇴 후 정보가 삭제되어 복구가 불가능 합니다.
                                                    <br/>
                                                    <br/>
                                                    소비자 보호에 관한 법률 제 6조에 의거, 계약 또는 청약철회 등에 관한 기록은 5년, 대금 결제 및 재화 등의 공급에 관한 기록은 5년 ,
                                                    소비자 불만 또는 분쟁처리 기록은 3년동안
                                                    보관됩니다. 동 개인정보는 법률에 의한 보유 목적 외에 다른 목적으로 이용되지 않습니다.
                                                    회원 탈퇴 후 30일 이후 재가입 하실 수 있습니다
                                                    <br/>
                                                    <br/>
                                                    재가입 방지를 위해 30일동안 회원정보를 보관 합니다.
                                            </div>
                                            <div className="text_center" style={{height:'32px'}}>
                                                <CheckBoxInput title="위의 안내 사항을 확인하였습니다." onClick={handleConfirm} defaultValue={confirm}
                                                    labelmargin="0px 0px 0px 7px" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="text_center">
                        <MyDropButtonBlock disable={checkValid() ?  "":"none"} colorF={checkValid() ? "#ccc":"#e0e0e0" }
                        onClick={handleApply} textColor={checkValid() ? "#333":"#ccc"}>
                        회원탈퇴 요청
                        </MyDropButtonBlock>
                            {/* <NormalBtn text="회원탈퇴 요청"
                                width="140px" height="40px" minWidth = "140px"
                                fontSize="14x" display="inline-block" marginRight="30px"
                                borderRadius="20px" textColor="#111" float="none"
                                onClick={handleApply} bgColor="#ccc" fontWeight="400"
                                marginTop='0px'
                            /> */}
                            <NormalBtn text="회원탈퇴 취소" width="140px" height="40px" minWidth = "140px"
                                borderRadius="20px" fontWeight="400"
                                float="none" fontSize="14px" bgColor="#111"
                                display="inline-block" onClick={handleCancel}
                                marginTop='0px' />

                        </div>

                    </MyDropTableWrapBlock>

                </MyDropContentsBlock>

            </MyDropWrapBlock>
            <Footer />
            <Modal
                isOpen={openModal2}
                onRequestClose={() => { setOpenModal2(false) }}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>

                <NormalPopup
                text=""
                text2={textQuestion}
                text3=""
                btn1="회원탈퇴" btn2="탈퇴취소"
                onClick1={handleModalDropBtnClick}
                onClick2={() => { setOpenModal2(false) }} />

            </Modal>
            <Modal
                isOpen={openModal1}
                onRequestClose={handleOneBtnPopupClick}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>

                <NormalPopupOneBtn
                text=""
                text2={textDrop} text3=""
                btn="확인" onClick={handleOneBtnPopupClick} />

            </Modal>
        </MyDropBlock>
    );
};

export default MyDrop;
